import { render, staticRenderFns } from "./CardGroupV2.vue?vue&type=template&id=495b680e&scoped=true"
import script from "./CardGroupV2.vue?vue&type=script&lang=js"
export * from "./CardGroupV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495b680e",
  null
  
)

export default component.exports